// Staff Membership Members
export const STAFF_MEMBERSHIP_MEMBER_GET_MEMBER_DIRECTORY_REQUEST = 'STAFF_MEMBERSHIP_MEMBER_GET_MEMBER_DIRECTORY_REQUEST';
export const STAFF_MEMBERHISP_MEMBER_GET_MEMBER_DIRECTORY_SUCCESS = 'STAFF_MEMBERHISP_MEMBER_GET_MEMBER_DIRECTORY_SUCCESS';
export const STAFF_MEMBERSHIP_MEMBER_GET_MEMBER_DIRECTORY_FAILURE = 'STAFF_MEMBERSHIP_MEMBER_GET_MEMBER_DIRECTORY_FAILURE';

export const STAFF_MEMBERHISP_MEMBER_GET_ALL_MEMBER_DIRECTORY_SUCCESS = 'STAFF_MEMBERHISP_MEMBER_GET_ALL_MEMBER_DIRECTORY_SUCCESS';

export const STAFF_MEMBERHISP_MEMBER_GET_ORGANISATION_CATGORIES_SUCCESS = 'STAFF_MEMBERHISP_MEMBER_GET_ORGANISATION_CATGORIES_SUCCESS';
